var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{class:_vm.buttonClasses,attrs:{"title":_vm.title},on:{"click":_vm.pageChange}},[_c('a',{staticClass:"page-link",domProps:{"innerHTML":_vm._s(_vm.html)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }